import { useQuery } from "react-query";
import { getProducts } from "Requests/Products";
import { createToast } from "Utils/toastFunc";
import { ProductFromAPI } from "../interface";

export const useProductsByIds = (productIds: number[]) => {
  const { data, isLoading, isError, error, refetch } = useQuery<
    ProductFromAPI[],
    Error
  >(
    ["products-by-ids", productIds],
    async () => {
      if (!productIds.length) {
        return [];
      }

      try {
        // Usar a função getProducts modificada com productIds
        // Isso vai criar a query string com múltiplos product_ids[]= sem colchetes
        const response = await getProducts({
          page: 1,
          filters: {
            product_ids: productIds as any,
            categories: "1,2,3",
            services: "4",
            channel_id: 4,
          },
        });

        const foundProducts = response.data || [];
        return foundProducts;
      } catch (err) {
        // Se falhar, tentar buscar individualmente
        console.warn("Falha ao buscar produtos em lote", err);

        return [];
      }
    },
    {
      enabled: productIds.length > 0,
      refetchOnWindowFocus: false,
      onError: (error: Error) => {
        if (error.message) return createToast("error", error.message);

        createToast("error", "Não foi possível encontrar os produtos");
      },
    }
  );

  const products: ProductFromAPI[] = data || [];

  // Verificar se todos os produtos foram encontrados
  const foundProductIds = products.map((p) => p.id);
  const missingProductIds = productIds.filter(
    (id) => !foundProductIds.includes(id)
  );
  const allProductsFound = missingProductIds.length === 0;

  return {
    products,
    isLoading,
    isError,
    error,
    refetch,
    allProductsFound,
    missingProductIds,
    foundProductIds,
    totalRequested: productIds.length,
    totalFound: products.length,
  };
};
